import React, { useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  Card,
  CardActions,
  Tabs,
  Tab,
  Divider,
  Stack,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import "../styles/layout/LandingPage.scss";
import PageIntro from "../components/pageintro";
import TabContent from "../components/tabcontents";
import WhyTecloqCards from "../components/whytecloqcards";

const whydata = [
  {
    src: "/assets/DataAnalytics/Tableau/why1.gif",
    alt: "why1",
    title: "Certified Tableau Consulting Support",
    description:
      "Leveraging cutting-edge big data platforms and cloud data engineering techniques, we build robust data warehousing solutions tailored to your specific requirements. Say goodbye to data silos and gain a holistic view of your business.",
  },
  {
    src: "/assets/DataAnalytics/Tableau/why2.gif",
    alt: "why2",
    title: "No More Data-related Problems",
    description:
      "Tecloq's data engineers are skilled in designing and implementing high-performance data pipelines. Whether you need real-time data streaming or batch processing, we have the expertise to optimize your data flow and enable smooth data integration.",
  },
  {
    src: "/assets/DataAnalytics/Tableau/why3.gif",
    alt: "why3",
    title: "Operational Profitability",
    description:
      "Our Data Visualization I services bridge the gap between raw data and meaningful information. We use advanced data visualization tools and techniques to create intuitive dashboards and reports, empowering you to make informed decisions quickly and effectively.",
  },
];

const tabsData = [
  {
    label: "Sales",
    title: "Sales",
    content:
      "Tableau Sales Dashboards for presenting essential and actionable data on sales pipeline, growth, quarterly forecasts, account management, and more, allowing you to make data-driven decisions quickly.",
    image: "/assets/DataAnalytics/Tableau/sales.webp",
  },
  {
    label: "Marketing",
    title: "Marketing",
    content:
      "Tableau Marketing Dashboards provide insightful visualizations of key metrics regarding your customer journeys, website performance, social media presence, and digital media expenditures.",
    image: "/assets/DataAnalytics/Tableau/marketing.webp",
  },
  {
    label: "Finance",
    title: "Finance",
    content:
      "Tableau Financial Dashboards to bring data together and maximise the effect of your time and resources while securely sharing the information that drives corporate strategy.",
    image: "/assets/DataAnalytics/Tableau/finance.webp",
  },
  {
    label: "Customer Service",
    title: "Customer Service",
    content:
      "Tableau Customer Service Dashboards to analyze key figures and trends in business, including customer satisfaction, response time, and SLA compliance. Set notifications to keep everyone informed, provide alerts if metrics fall short of goals, and coordinate efforts across teams.",
    image: "/assets/DataAnalytics/Tableau/csd.webp",
  },
];

const Tableau = () => {
  // State to track the active tab
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to handle tab change
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/DataAnalytics/Tableau/background2.jpeg"}
        subheading={"Dive Deeper, Decide Smarter"}
        heading={"Tableau Consulting Services"}
        desc={"Dive Deeper, Decide Smarter"}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Keep row on desktop
          maxWidth: "100%",
          gap: "3%",
          margin: "3% 5% 3% 10%",
          "@media (max-width: 600px)": {
            flexDirection: "column", // Change to column only on mobile
            margin: "3% 5%",
          },
        }}
      >
        <Card
          elevation={0}
          sx={{
            width: "60%",
            height: "auto",
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: "40px",
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "8%",
              "@media (max-width: 600px)": {
                fontSize: "24px", // Adjust font size for mobile
                justifyContent: "center",
                textAlign: "center",
              },
            }}
          >
            Tableau Consulting Services
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "normal",
              fontSize: "22px",
              color: "#000000",
              lineHeight: "120%",
              textAlign: "left",
              width: "80%",
              "@media (max-width: 600px)": {
                fontSize: "16px", // Adjust font size for mobile
                textAlign: "center",
                width: "100%",
              },
            }}
          >
            We help you harness tailored data analytics to visualize & discern
            crucial insights, and curate intuitive reports. Our Tableau
            Consulting Services extensively cover every facet of business
            intelligence that help produce remarkable results.
          </Typography>
          <CardActions
            sx={{
              display: "flex",
              flexDirection: "row", // Keep row on desktop
              gap: "10%",
              padding: "10% 0 0 0",
              "@media (max-width: 600px)": {
                flexDirection: "column", // Stack vertically on mobile
                gap: "5%",
                alignItems: "center",
              },
            }}
          >
            <Link to="/clientForm" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  width: "210px",
                  height: "52.23px",
                  backgroundColor: "#F005A2",
                  borderRadius: "45.25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 10px",
                  "@media (max-width: 600px)": {
                    width: "100%", // Full width on mobile
                    marginBottom: "5%",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Plus Jakarta Sans, sans-serif",
                    fontWeight: "bold",
                    color: "#000000",
                    fontSize: "17px",
                    letterSpacing: "0.08rem",
                  }}
                >
                  For Clients
                </Typography>
                <Box
                  sx={{
                    width: "35.84px",
                    height: "35.23px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "45.25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ArrowForwardIcon />
                </Box>
              </Box>
            </Link>
            <Link to="/Careers" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  width: "260px",
                  height: "52.23px",
                  backgroundColor: "#F005A2",
                  borderRadius: "45.25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 10px",
                  "@media (max-width: 600px)": {
                    width: "100%", // Full width on mobile
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Plus Jakarta Sans, sans-serif",
                    fontWeight: "bold",
                    color: "#000000",
                    fontSize: "17px",
                    letterSpacing: "0.08rem",
                  }}
                >
                  For Developers
                </Typography>
                <Box
                  sx={{
                    width: "35.84px",
                    height: "35.23px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "45.25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ArrowForwardIcon />
                </Box>
              </Box>
            </Link>
          </CardActions>
        </Card>

        <Box
          sx={{
            width: "44%",
            display: "flex",
            justifyContent: "center",
            paddingTop: "3%",
            "@media (max-width: 600px)": {
              width: "100%", // Full width on mobile
              paddingTop: "5%",
            },
          }}
        >
          <img
            src="/assets/DataAnalytics/Tableau/tcs.webp"
            loading="lazy"
            alt="tcs"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Box>

      <Box sx={{ margin: "8% 2% 5% 2%", padding: "0 !important" }}>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "5%", sm: "4%", md: "3%" }, // Responsive padding
          }}
        >
          Our Custom Dashboards
        </Typography>

        {/* Tabs */}
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "3%" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            centered
            sx={{
              width: "85%",
              "& .MuiTabs-flexContainer": {
                justifyContent: "center", // Center tabs when they fit
                // gap: { xs: "4px", sm: "8px" }, // Add small gaps for better spacing on smaller screens
              },
              "& .MuiTab-root": {
                fontSize: { xs: "10px", sm: "14px", md: "24px" }, // Shrink font size on smaller screens
                flexGrow: 1, // Allows tabs to shrink
                minWidth: 0, // Prevents fixed width and allows shrinking
                maxWidth: "240px", // Controls max width of each tab
                textTransform: "none",
                borderRadius: "1px",
                backgroundColor: "#E8E8E8", // Default color when not selected
                color: "#000", // Text color when not selected
                transition: "all 0.1s ease",
                padding: { xs: "4px 8px", sm: "6px 12px" }, // Adjust padding for better touch targets on mobile
                height: { xs: "36px", sm: "48px" }, // Adjust height for better touch experience
              },
              "& .MuiTab-root.Mui-selected": {
                backgroundColor: "#F005A2", // Active tab color
                color: "#FFFFFF", // Text color for selected tab
                fontWeight: "bold",
              },
              "& .MuiTabs-indicator": {
                display: "none", // Hide default Material-UI underline
              },
            }}
          >
            {tabsData.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                sx={{
                  fontFamily: "Inter",
                  fontSize: { xs: "12px", md: "46px" }, // Responsive font size
                }}
              />
            ))}
          </Tabs>
        </Box>
        {/* Divider */}
        <Divider
          sx={{ marginTop: "10px", backgroundColor: "#000000", height: "0.1%" }}
        />
        {/* Tab Content Below Divider */}
        <Box sx={{ margin: "3% 0 0 10%" }}>
          <TabContent
            title={tabsData[selectedTab].title}
            content={tabsData[selectedTab].content}
            image={tabsData[selectedTab].image}
          />
        </Box>

        {/* <Box sx={{ padding: "20px", marginTop: "5%" }}>
          {selectedTab === 0 && (
            <Stack spacing={3} alignItems="center">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "normal",
                  maxWidth: "100%",
                  fontFamily: "Inter",
                  fontSize: "24px",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                Tableau Sales Dashboards for presenting essential and actionable
                data on sales pipeline, growth, quarterly forecasts, account
                management, and more, allowing you to make data-driven decisions
                quickly.
              </Typography>
              <img
                src="/assets/DataAnalytics/Tableau/sales.webp"
                loading="lazy"
                alt="Sales Dashboard"
                style={{ width: "60%", height: "auto", textAlign: "center" }}
              />
            </Stack>
          )}
          {selectedTab === 1 && (
            <Stack spacing={3} alignItems="center">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "normal",
                  maxWidth: "100%",
                  fontFamily: "Inter",
                  fontSize: "24px",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                Tableau Marketing Dashboards provide insightful visualizations
                of key metrics regarding your customer journeys, website
                performance, social media presence, and digital media
                expenditures.
              </Typography>
              <img
                src="/assets/DataAnalytics/Tableau/marketing.webp"
                loading="lazy"
                alt="Marketing Dashboard"
                style={{ width: "60%", height: "auto", textAlign: "center" }}
              />
            </Stack>
          )}
          {selectedTab === 2 && (
            <Stack spacing={3} alignItems="center">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "normal",
                  maxWidth: "100%",
                  fontFamily: "Inter",
                  fontSize: "24px",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                Tableau Financial Dashboards to bring data together and maximise
                the effect of your time and resources while securely sharing the
                information that drives corporate strategy.
              </Typography>
              <img
                src="/assets/DataAnalytics/Tableau/finance.webp"
                loading="lazy"
                alt="Finance Dashboard"
                style={{ width: "60%", height: "auto", textAlign: "center" }}
              />
            </Stack>
          )}
          {selectedTab === 3 && (
            <Stack spacing={3} alignItems="center">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "normal",
                  maxWidth: "100%",
                  fontFamily: "Inter",
                  fontSize: "24px",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                Tableau Customer Service Dashboards to analyze key figures and
                trends in business, including customer satisfaction, response
                time, and SLA compliance. Set notifications to keep everyone
                informed, provide alerts if metrics fall short of goals, and
                coordinate efforts across teams.
              </Typography>
              <img
                src="/assets/DataAnalytics/Tableau/csd.webp"
                loading="lazy"
                alt="Customer service Dashboard"
                style={{ width: "60%", height: "auto", textAlign: "center" }}
              />
            </Stack>
          )}
        </Box> */}
      </Box>

      <Box>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "8%", sm: "6%", md: "5%" }, // Responsive padding
            textAlign: "center", // Ensures alignment on smaller screens
          }}
        >
          Why Tableau Consulting Services?
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: { md: "60px" },
            flexWrap: "wrap",
            gap: "20px",
            marginBottom: "5%",
          }}
        >
          {[
            {
              img: "/assets/DataAnalytics/Tableau/T1.png",
              title: "Simple-To-Use",
              desc: "Relish the diverse range of simple-to-use solutions offered by Tableau to enable data accumulation, in-depth analysis, and improved visualization.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T2.png",
              title: "Data Visualizations",
              desc: "Create and get interactive and easy-to-comprehend visualizations with Tableau Services that lets you uncover your data to derive insights effortlessly and unlock ultimate performance.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T3.png",
              title: "Swift Implementation",
              desc: "Get actionable business insights from your valuable data effortlessly and quickly. Analyze, and share your data in just a few minutes.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T4.png",
              title: "Data Handling",
              desc: "Effectively manage static and real-time data and extract vast amounts of data from numerous external sources.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T5.png",
              title: "Data-driven Decision Making",
              desc: "Our technical Tableau experts create stunning dashboards for you, offer thought leadership, advise on the best chart to use, the best look and feel, and offer design advice.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T6.png",
              title: "Unified and Governed Data",
              desc: "We can assist in fine-tuning and enhancing the Tableau implementation’s performance so that you quickly obtain the desired outcomes.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T7.png",
              title: "High Scalability",
              desc: "We can assist in developing the best BI strategy, which includes BI solution building, installation, deployment, administration, integration, etc., based on the needs of your business.",
            },
            {
              img: "/assets/DataAnalytics/Tableau/T8.png",
              title: "Competitive Advantage",
              desc: "We can assist in developing the best BI strategy, which includes BI solution building, installation, deployment, administration, integration, etc., based on the needs of your business.",
            },
          ].map((item, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                borderRadius: "3%",
                textAlign: "center",
                border: "0.5px solid #FFC3EA",
                boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
                display: "flex",
                flexDirection: "column",
                background:
                  "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
                width: { xs: "90%", sm: "250px" },
                height: { xs: "auto", sm: "420px" },
                padding: "2%",
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  width: "30%",
                  height: "auto",
                  margin: "0 auto",
                  paddingTop: "10%",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  lineHeight: "120%",
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  color: "#F005A2",
                  padding: "10% 5% 0",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: { xs: "14px", sm: "18px" },
                  padding: "5% 5% 3%",
                }}
              >
                {item.desc}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "6%" }, // Adjust margin for different screens
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
          }}
        >
          Why Tecloq?
        </Typography>
      </Box>

      <WhyTecloqCards data={whydata} />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "6%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          Our Offerings
        </Typography>
        <img
          src="/assets/DataAnalytics/Tableau/offers.webp"
          loading="lazy"
          alt="offer"
          style={{
            height: "auto",
            width: "90%", // Wider on smaller screens
            maxWidth: "70%", // Keep larger size on PC
            margin: "5% 0",
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: { md: "60px" },
          flexWrap: "wrap",
          gap: "20px",
          marginBottom: "5%",
        }}
      >
        {[
          {
            img: "/assets/DataAnalytics/Tableau/o1.png",
            title: "Tableau BI Solution Development",
            desc: "Our technical Tableau experts create stunning dashboards for you, offer thought leadership, advise on the best chart to use, the best look and feel, and offer design advice.",
          },
          {
            img: "/assets/DataAnalytics/Tableau/o2.png",
            title: "Tableau Performance Tuning & Analysis",
            desc: "We can assist in fine-tuning and enhancing the Tableau implementation’s performance so that you quickly obtain the desired outcomes.",
          },
          {
            img: "/assets/DataAnalytics/Tableau/o3.png",
            title: "Tableau Deployment & Administration",
            desc: "Get actionable business insights from your valuable data effortlessly and quickly. Analyze, and share your data in just a few minutes.",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
              background:
                "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
              width: { xs: "90%", sm: "250px" },
              height: { xs: "auto", sm: "420px" },
              padding: "2%",
            }}
          >
            <img
              src={item.img}
              alt={item.title}
              style={{
                width: "30%",
                height: "auto",
                margin: "0 auto",
                paddingTop: "10%",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: { xs: "18px", sm: "24px" },
                fontWeight: "700",
                color: "#F005A2",
                padding: "10% 5% 0",
              }}
            >
              {item.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "14px", sm: "18px" },
                padding: "5% 5% 3%",
              }}
            >
              {item.desc}
            </Typography>
          </Paper>
        ))}
      </Box>

     
      <Box
  sx={{
    maxWidth: "100%",
    height: "auto",
    marginTop: "6%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    paddingX: { xs: "5%", sm: "10%", md: "0" },
  }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", sm: "32px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      paddingBottom: "1%",
      textAlign: "center",
    }}
  >
    Our process
  </Typography>

  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "lighter",
      fontSize: { xs: "14px", sm: "16px", md: "20px" },
      color: "#000000",
      margin: { xs: "2% 5%", sm: "2% 10%", md: "1% 15% 2% 15%" },
      textAlign: "center",
    }}
  >
    Discovering insights from the ever-growing volume of data has become
    crucial in today's fiercely competitive business environment. Tableau, a
    data visualisation tool, helps businesses compile data from across the
    organisation and create reports using straightforward drag-and-drop
    functionality.
  </Typography>

  <img
    src="/assets/DataAnalytics/Tableau/process.gif"
    alt="process"
    style={{
      height: "auto",
      width: "100%",
      maxWidth: "800px",
      marginBottom: "5%",
      borderRadius: "8px",
    }}
  />
</Box>

    </Box>
  );
};

export default Tableau;
